export default __webpack_public_path__ + "static/media/banner.3464115d.png";